"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VizClientDatasourceElement = void 0;
const tslib_1 = require("tslib");
const catalog_core_1 = require("@tableau/catalog-core");
const catalog_icons_1 = require("@tableau/catalog-icons");
const catalog_messages_1 = require("@tableau/catalog-messages");
const data_catalog_shared_1 = require("@tableau/data-catalog-shared");
const react_1 = tslib_1.__importDefault(require("react"));
const LabelsHookHelper_1 = require("../Labels/LabelsHookHelper");
const PublishedDatasourceIcon_1 = require("./PublishedDatasourceIcon");
const ViewerPaneStyles_1 = require("./ViewerPaneStyles");
const lastRefreshedLabelMinWidth = 87; // hack to prevent from wrapping to new line when scrollbars appear
/** A widget to display a single datasource */
function VizClientDatasourceElement(props) {
    const urls = (0, catalog_core_1.useSiteUrls)();
    return (react_1.default.createElement(ViewerPaneStyles_1.DatasourceListBodyElement, { "data-tb-test-id": 'vizclient-datasource-element-test-id' },
        react_1.default.createElement(ViewerPaneStyles_1.DatasourceIconNameContainer, null,
            react_1.default.createElement(LabelsHookHelper_1.LabelWrapper, { itemInfo: props.datasource, category: 'warning', isEager: false, kind: 'icon', popoverPlacement: 'left', wrapper: (e) => react_1.default.createElement(ViewerPaneStyles_1.LabelIconWrapper, null, e) }),
            react_1.default.createElement(data_catalog_shared_1.MultiLineLinkWithIcon, { linkText: props.datasource.name, linkHref: urls.workbookLineageFieldsUrl(props.workbookVizportalUrlId, props.datasource.id), iconComponent: react_1.default.createElement(DatasourceIconElement, { datasource: props.datasource }), iconPosition: 'top', iconSize: 'medium' })),
        react_1.default.createElement(DatasourceConnections, { datasource: props.datasource }),
        // Only display the database connections if the embedded datasource is connected to
        // a local file/table (i.e., not to a published datasource)
        !props.datasource.hasPublishedDatasource
            && (react_1.default.createElement(DatasourceDatabasesConnections, { "data-foo": 'foo', connections: props.datasource.databasesConnectionNodes, datasource: props.datasource }))));
}
exports.VizClientDatasourceElement = VizClientDatasourceElement;
function DatasourceIconElement(props) {
    return props.datasource.__typename === 'EmbeddedDatasource'
        ? react_1.default.createElement(catalog_icons_1.SvgSpacesMediumDsEmbedded, null)
        : null; // No icon for published data sources
}
function DatasourceConnections(props) {
    if (!props.datasource.hasPublishedDatasource) {
        return null;
    }
    return (react_1.default.createElement(data_catalog_shared_1.MetadataTable.Table, { valueCellFlexGrow: 2 },
        react_1.default.createElement(PublishedDatasourceConnectionIconNameRow, { datasource: props.datasource.publishedDatasource }),
        react_1.default.createElement(PublishedDatasourceExtractLiveRow, { datasource: props.datasource, publishedDatasource: props.datasource.publishedDatasource })));
}
function DatasourceDatabasesConnections(props) {
    if (!props.connections) {
        return null;
    }
    return (react_1.default.createElement(data_catalog_shared_1.MetadataTable.Table, { valueCellFlexGrow: 2, "data-tb-test-id": 'datasource-databases-connections-test-id' }, props.connections.map(connection => (react_1.default.createElement(react_1.default.Fragment, { key: connection.id },
        react_1.default.createElement(EmbeddedDatasourceConnectionIconNameRow, { connection: connection }),
        react_1.default.createElement(EmbeddedDatasourceExtractLiveRow, { connection: connection, datasource: props.datasource }))))));
}
function EmbeddedDatasourceConnectionIconNameRow(props) {
    const siteUrls = (0, catalog_core_1.useSiteUrls)();
    const isObfuscated = props.connection === null || props.connection.name === null;
    return (react_1.default.createElement(data_catalog_shared_1.MetadataTable.Row, null,
        react_1.default.createElement(data_catalog_shared_1.MetadataTable.LabelCell, { style: (0, data_catalog_shared_1.getPaddingTopStyleForTextWithIcon)({ iconSize: 'medium' }) }, catalog_messages_1.Messages.DatasourceConnectionLabel()),
        react_1.default.createElement(data_catalog_shared_1.MetadataTable.ValueCell, null, isObfuscated
            ? (0, data_catalog_shared_1.ViewerPaneObfuscatedPlaceholder)()
            : (react_1.default.createElement(data_catalog_shared_1.MultiLineLinkWithIcon, { iconComponent: props.connection
                    ? (0, data_catalog_shared_1.DatabaseMediumIcon)({
                        database: {
                            __typename: props.connection.__typename,
                            connectionType: props.connection.connectionType,
                            isCertified: props.connection.isCertified || false,
                        },
                    })
                    : react_1.default.createElement("div", null), iconSize: 'medium', iconPosition: 'top', linkText: props.connection && props.connection.name || '', linkHref: props.connection && siteUrls.catalogDatabaseUrl(props.connection.id) || '' })))));
}
function EmbeddedDatasourceExtractLiveRow(props) {
    return (react_1.default.createElement(data_catalog_shared_1.MetadataTable.Row, null,
        react_1.default.createElement(data_catalog_shared_1.MetadataTable.LabelCell, { style: { minWidth: lastRefreshedLabelMinWidth } }, catalog_messages_1.Messages.DatasourceExtractLiveLabel()),
        react_1.default.createElement(data_catalog_shared_1.MetadataTable.ValueCell, null, props.datasource.hasExtracts
            ? (props.datasource.extractLastUpdateTime
                ? catalog_messages_1.Formatters.formatMediumDateTimeWithoutSeconds(new Date(props.datasource.extractLastUpdateTime))
                : catalog_messages_1.Messages.DatasourceExtractValue())
            : catalog_messages_1.Messages.DatasourceLiveValue())));
}
function PublishedDatasourceConnectionIconNameRow(props) {
    const siteUrls = (0, catalog_core_1.useSiteUrls)();
    const isObfuscated = props.datasource === null || props.datasource.name === null;
    return (react_1.default.createElement(data_catalog_shared_1.MetadataTable.Row, null,
        react_1.default.createElement(data_catalog_shared_1.MetadataTable.LabelCell, { style: (0, data_catalog_shared_1.getPaddingTopStyleForTextWithIcon)({ iconSize: 'medium' }) }, catalog_messages_1.Messages.DatasourceConnectionLabel()),
        react_1.default.createElement(data_catalog_shared_1.MetadataTable.ValueCell, null, isObfuscated
            ? (0, data_catalog_shared_1.ViewerPaneObfuscatedPlaceholder)()
            : (react_1.default.createElement(data_catalog_shared_1.MultiLineLinkWithIcon, { iconComponent: props.datasource
                    && (0, PublishedDatasourceIcon_1.PublishedDatasourceIcon)({
                        hasExtracts: !!props.datasource.hasExtracts,
                        isCertified: props.datasource.isCertified,
                    }), iconSize: 'medium', iconPosition: 'top', iconTitle: props.datasource
                    && (0, PublishedDatasourceIcon_1.PublishedDatasourceIconTooltip)({
                        hasExtracts: !!props.datasource.hasExtracts,
                        isCertified: props.datasource.isCertified,
                    }), linkText: props.datasource && props.datasource.name || '', linkHref: siteUrls.datasourceLineageFieldsUrl(props.datasource && props.datasource.vizportalUrlId || '') })))));
}
function PublishedDatasourceExtractLiveRow(props) {
    const isObfuscated = props.publishedDatasource === null || props.publishedDatasource.name === null;
    if (!props.datasource.hasExtracts && isObfuscated) {
        return null;
    }
    const hasExtracts = props.datasource.hasExtracts
        || (props.publishedDatasource && props.publishedDatasource.hasExtracts);
    let extractText;
    if (hasExtracts) {
        if (props.datasource.extractLastUpdateTime) {
            extractText = catalog_messages_1.Formatters.formatMediumDateTimeWithoutSeconds(new Date(props.datasource.extractLastUpdateTime));
        }
        else if (props.publishedDatasource && props.publishedDatasource.extractLastUpdateTime) {
            extractText = catalog_messages_1.Formatters
                .formatMediumDateTimeWithoutSeconds(new Date(props.publishedDatasource.extractLastUpdateTime));
        }
        else {
            extractText = catalog_messages_1.Messages.DatasourceExtractValue();
        }
    }
    else {
        extractText = catalog_messages_1.Messages.DatasourceLiveValue();
    }
    return (react_1.default.createElement(data_catalog_shared_1.MetadataTable.Row, null,
        react_1.default.createElement(data_catalog_shared_1.MetadataTable.LabelCell, { style: { minWidth: lastRefreshedLabelMinWidth } }, catalog_messages_1.Messages.DatasourceExtractLiveLabel()),
        react_1.default.createElement(data_catalog_shared_1.MetadataTable.ValueCell, null, extractText)));
}
//# sourceMappingURL=VizClientDatasourceElement.js.map